var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-lg-12"},[_c('ExportLandingPage',{attrs:{"listBlockLP":_vm.dataForm.blocks_settings,"dataForm":_vm.dataForm}})],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }